import { LanguageProvider, useLanguage } from "./i18n/LanguageContext";
import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import ServicesSection from "./components/ServicesSection";
import ApproachSection from "./components/ApproachSection";
import WhyChooseUs from "./components/WhyChooseUs";
import WomensSection from "./components/WomensSection";
import EquipmentSection from "./components/EquipmentSection";
import GallerySection from "./components/GallerySection";
import ReviewsSection from "./components/ReviewsSection";
import StoriesSection from "./components/StoriesSection";
import WorkingHours from "./components/WorkingHours";
import FaqSection from "./components/FaqSection";
import TeamSection from "./components/TeamSection";
import ContactSection from "./components/ContactSection";
import AppointmentForm from "./components/AppointmentForm";
import SiteFooter from "./components/SiteFooter";
import MobileCtaBar from "./components/MobileCtaBar";
import GoToTop from "./components/GoToTop";
import SocialBar from "./components/SocialBar";
import ScrollProgress from "./components/ScrollProgress";

const Shell = () => {
    const { t } = useLanguage();
    return (
        <div id="top" className="min-h-screen bg-sand text-ink">
            <a
                href="#main"
                data-testid="skip-to-content"
                className="sr-only focus:not-sr-only focus:fixed focus:start-3 focus:top-3 focus:z-[60] focus:rounded-full focus:bg-pine focus:px-5 focus:py-3 focus:text-sm focus:font-semibold focus:text-cream"
            >
                {t.skip}
            </a>
            <SiteHeader />
            <ScrollProgress />
            <main id="main" className="pb-20 md:pb-0">
                <Hero />
                <IntroSection />
                <ServicesSection />
                <ApproachSection />
                <WhyChooseUs />
                <WomensSection />
                <EquipmentSection />
                <GallerySection />
                <ReviewsSection />
                <StoriesSection />
                <WorkingHours />
                <FaqSection />
                <TeamSection />
                <ContactSection />
                <AppointmentForm />
            </main>
            <SiteFooter />
            <MobileCtaBar />
            <GoToTop />
            <SocialBar />
        </div>
    );
};

export default function App() {
    return (
        <LanguageProvider>
            <Shell />
        </LanguageProvider>
    );
}
